import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { inject } from '@angular/core';
import { IsLoginService } from './is-login.service';

export const AuthguardGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean => {
  const router = inject(Router);
  const isLoginService = inject(IsLoginService);

  const routeurl: string = state?.url;
  const qParams = route.queryParams;

  const manageExtParams = (qParams: any) => {
    isLoginService.setToken(qParams.token);
    if (qParams.period !== undefined) {
      isLoginService.setCookie('period', qParams.period);
    }
    if (qParams.time_from !== undefined) {
      isLoginService.setCookie('time_from', qParams.time_from);
    }
    if (qParams.time_to !== undefined) {
      isLoginService.setCookie('time_to', qParams.time_to);
    }
  };

  const isLogin = (): boolean => {
    if (isLoginService.isLoggedIn()) {
      if (qParams.token !== undefined) {
        manageExtParams(qParams);
        const newrouterurl: string = routeurl.split('?')[0];
        router.navigate([newrouterurl], { queryParams: {} });
      }
      return true;
    } else if (qParams.token !== undefined) {
      manageExtParams(qParams);
      const newrouterurl: string = routeurl.split('?')[0];
      router.navigate([newrouterurl], { queryParams: {} });
      return true;
    } else {
      isLoginService.redirectUrl = routeurl;
      router.navigate(['/login'], {
        queryParams: { returnUrl: routeurl }
      });
      return false;
    }
  };

  return isLogin();
};
